const assert = require('assert'),
  {wix} = require('./lib/generated/proto-generated'),
  {constructMessage} = require('./lib/message'),
  {GrpcStatus} = require('./lib/grpc-status'),
  trailers = require('./lib/trailers'),
  protoRuntime = require('@wix/wix-proto-runtime-toolkit'),
  {
    WixBaseError,
    WixError,
    wixBusinessError,
    WixBusinessError,
    wixSystemError,
    WixSystemError,
    WixUnsupportedBrowserError,
    HttpStatus,
    ErrorCode,
    extractMetadata,
    isBusinessError,
    ThrottledError
  } = require('@wix/wnp-errors-base');

// NOTE: this is legacy class. It will be removed in future.
// wix-express-proto expects these errors to be thrown from Protobuf-defined services
// when WNP_EMULATE_GRPC_ERRORS feature toggle !== true
class GrpcError extends WixBaseError {
  constructor(code, message, details, cause) {
    super(message, {cause});
    this._errorCode = ErrorCode.GRPC_ERROR;
    this.code = code;
    this.details = details;
    this._exposeMessage = true;
  }
}

const {GRPC_STATUS_DETAILS} = trailers;

class GrpcStatusError extends WixBaseError {
  constructor(status, message, metadata, cause, name, {callInfo} = {}) {
    if (callInfo) {
      validateCallInfo(callInfo);
    }
    const code = GrpcStatus.asNumber(status) || GrpcStatus.UNKNOWN;
    super(constructMessage(code, message, {callInfo}), {cause, name});
    this.code = code;
    this.callInfo = callInfo;
    if (metadata) {
      this.metadata = metadata;
    }
    if (this.details) {
      this._exposeMessage = true;
    }
  }

  get details() {
    return this.metadata && this.metadata[GRPC_STATUS_DETAILS];
  }

  withCallInfo(callInfo) {
    validateCallInfo(callInfo);
    const copy = new GrpcStatusError(this.code, this.message, this.metadata, this.cause, this.name, {callInfo});
    copy.stack = this.stack;
    return copy;
  }

  putStatusInErrorName() {
    let code = this.details && this.details.applicationError && this.details.applicationError.code;
    code = code ? `_${code}` : '';
    this.name = `${this.name}_${GrpcStatus.asString(this.code)}${code}`;
    return this;
  }

  static applicationError(code, message, applicationError, name) {
    return new GrpcStatusError(code, message, wrapErrorDetails({applicationError}), null, name);
  }

  static validationError(code, message, validationError) {
    return new GrpcStatusError(code, message, wrapErrorDetails({validationError}), null, 'GrpcValidationError');
  }
}

function validateCallInfo(callInfo) {
  assert(callInfo && typeof callInfo === 'object', 'object required');
  assert(typeof callInfo.service === 'string', 'service is required and must be a string');
  assert(typeof callInfo.url === 'string', 'url is required and must be a string');
  assert(typeof callInfo.method === 'string', 'method is required and must be a string');
}

function wrapErrorDetails(details) {
  const errors = wix.api.Details.verify(details, protoRuntime);
  if (!errors.isEmpty()) {
    throw new TypeError(`Invalid error details: "${errors}"`);
  }
  return {[GRPC_STATUS_DETAILS]: details};
}
module.exports = {
  WixError,
  wixBusinessError,
  WixBusinessError,
  wixSystemError,
  WixSystemError,
  WixUnsupportedBrowserError,
  HttpStatus,
  ErrorCode,
  extractMetadata,
  isBusinessError,
  GrpcStatusError,
  GrpcStatus,
  GrpcError,
  ThrottledError,
  wix,
  trailers
};
